import {message} from "antd";
import {MSG_ERR_SYS_ERROR, MSG_TOO_MANY_REQUESTS_ERROR} from "./Messages";

const handleError = (errors: any) => {
    let responseErrors = errors.response;
    if (undefined === responseErrors) {
        message.error(errors.message)
    } else if (responseErrors.status && 429 === responseErrors.status) {
        message.error(MSG_TOO_MANY_REQUESTS_ERROR).then();
    } else if ("" == responseErrors.data) {
        message.error(MSG_ERR_SYS_ERROR).then();
    } else if (responseErrors.data.errors?.length) {
        message.error(responseErrors.data.errors[responseErrors.data.errors.length - 1].errorMessage).then();
    } else {
        message.error(MSG_ERR_SYS_ERROR).then();
    }
}


const ErrorHandler = {
    handleError
};


export default ErrorHandler;